import { UserWalletStatusEnum } from '#src/__generated__/globalTypes.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';

export const useWalletNeedsRecover = () => {
  const { currentUser } = useCurrentUserContext();

  if (!currentUser) {
    return false;
  }
  const { wallet } = currentUser;
  if (wallet) {
    return wallet.status !== UserWalletStatusEnum.READY;
  }
  // here it means that there is no wallet initialized and this needs to go through another chain
  return false;
};
